import { makeStyles, createStyles } from '@material-ui/core';

export const useStyles = makeStyles(() =>
  createStyles({
    solutionRules: {
      width: '300px',
      fontFamily: 'Roboto',
      fontStyle: 'normal',
      fontWeight: 500,
      fontSize: '13px',
      color: '#2C2D3E',
      margin: '10px 0px',
    },
    filesDragRow: {
      width: '300px',
    },
    validationErrorText: {
      fontWeight: 400,
      fontSize: 15,
    },
    validationErrorTextBold: {
      fontWeight: 800,
      fontSize: 15,
      whiteSpace: 'break-spaces',
    },
  }),
);
